import { render, staticRenderFns } from "./formInvoiceNew.vue?vue&type=template&id=65e8ff74&scoped=true&"
import script from "./formInvoiceNew.vue?vue&type=script&lang=js&"
export * from "./formInvoiceNew.vue?vue&type=script&lang=js&"
import style0 from "./formInvoiceNew.vue?vue&type=style&index=0&id=65e8ff74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e8ff74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e8ff74')) {
      api.createRecord('65e8ff74', component.options)
    } else {
      api.reload('65e8ff74', component.options)
    }
    module.hot.accept("./formInvoiceNew.vue?vue&type=template&id=65e8ff74&scoped=true&", function () {
      api.rerender('65e8ff74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/components/formInvoiceNew.vue"
export default component.exports